"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionProvider = exports.useSelection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SelectionContext = (0, react_1.createContext)(undefined);
const useSelection = () => {
    const ctx = (0, react_1.useContext)(SelectionContext);
    if (!ctx) {
        throw new Error("useSelection must be used within a SelectionProvider");
    }
    return ctx;
};
exports.useSelection = useSelection;
const SelectionProvider = ({ children }) => {
    const [selectedHtml, setSelectedHtml] = (0, react_1.useState)("");
    const [selectedElementIds, setSelectedElementIds] = (0, react_1.useState)([]);
    const [isSelectionMode, setIsSelectionMode] = (0, react_1.useState)(false);
    const clearSelection = () => {
        setSelectedHtml("");
        setSelectedElementIds([]);
        setIsSelectionMode(false);
    };
    return ((0, jsx_runtime_1.jsx)(SelectionContext.Provider, { value: {
            selectedHtml,
            setSelectedHtml,
            selectedElementIds,
            setSelectedElementIds,
            isSelectionMode,
            setIsSelectionMode,
            clearSelection,
        }, children: children }));
};
exports.SelectionProvider = SelectionProvider;
